import React, { useEffect, useState } from 'react';
import { getIconPublicUrl, toPublicUploadIconUrl } from '../core';
import apiFetch from '../../../utils/apiFetch';

function isLocalDevHost() {
  if (typeof window === 'undefined' || !window.location) return false;
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

function iconFilenameFromUrl(filePath) {
  const raw = decodeURIComponent(String(filePath || '').trim());
  const m = raw.match(/\/(?:uploads\/icons|api\/icons\/file)\/([^/?#]+)$/i);
  return m ? m[1] : '';
}

/** 开发时直连后端静态目录，避开 CRA 把 /uploads 回成网页 */
function backendUploadsUrl(filePath) {
  const name = iconFilenameFromUrl(filePath);
  if (!name) return '';
  const enc = encodeURIComponent(name);
  if (isLocalDevHost()) return `http://127.0.0.1:5000/uploads/icons/${enc}`;
  return `/api/icons/file/${enc}`;
}

/**
 * 图标缩略图（内置水滴或自定义 url）
 * 上传库走后端直链 / 带 token 的文件接口，避免预览被前端页面劫持。
 */
export default function IconThumb({
  iconKey = '',
  url,
  iconId,
  size = 24,
  alt = '',
  style = {},
  className
}) {
  const builtinSrc = (!url && !iconId) ? getIconPublicUrl(iconKey || 'water_drop') : '';
  const directSrc = url ? (backendUploadsUrl(url) || toPublicUploadIconUrl(url)) : '';
  const [blobSrc, setBlobSrc] = useState('');
  const h = Math.round(Number(size) * 1.28) || 30;

  useEffect(() => {
    // 本地已直连 :5000/uploads，不必再走尚未重启的新接口
    if (!iconId || (isLocalDevHost() && directSrc)) {
      setBlobSrc('');
      return undefined;
    }
    let dead = false;
    let obj = '';
    apiFetch(`/api/admin/icons/${iconId}/file`)
      .then(async (res) => {
        if (!res.ok) throw new Error('icon file');
        const blob = await res.blob();
        const type = String(res.headers.get('content-type') || blob.type || '');
        if (!type.includes('image') && !type.includes('svg')) {
          throw new Error('not image');
        }
        if (dead) return;
        obj = URL.createObjectURL(blob);
        setBlobSrc(obj);
      })
      .catch(() => {
        if (!dead) setBlobSrc('');
      });
    return () => {
      dead = true;
      if (obj) URL.revokeObjectURL(obj);
    };
  }, [iconId, directSrc]);

  const src = blobSrc || directSrc || builtinSrc;
  if (!src) return null;

  return (
    <img
      className={className}
      src={src}
      alt={alt || iconKey || ''}
      width={size}
      height={h}
      draggable={false}
      style={{ objectFit: 'contain', verticalAlign: 'middle', flexShrink: 0, ...style }}
    />
  );
}
